import * as PathNavigation from '../PathNavigation'
import amex from '../../images/paymentMethod/amex.svg'
import appStoreLogo from '../../images/footer/appstore.png'
import elo from '../../images/paymentMethod/elo.svg'
import googlePlayLogo from '../../images/footer/googleplay.png'
import hipercard from '../../images/paymentMethod/hipercard.svg'
import mail from '../../images/footer/mail.svg'
import mastercard from '../../images/paymentMethod/mastercard.svg'
import phone from '../../images/footer/logo_phone.svg'
import tagLogo from '../../images/footer/logo_footer.svg'
import visa from '../../images/paymentMethod/visa.svg'
import pix from '../../images/paymentMethod/pix.svg'
import whatsapp from '../../images/footer/logo_whatsapp.svg'

const contactMail = {
  'navigationList': [
    {
      'id': 1,
      'logo': mail,
      'name': 'assessoria@taglivros.com.br',
      'url': 'mailto:assessoria@taglivros.com.br'
    },
    {
      'id': 2,
      'logo': mail,
      'name': 'parcerias@taglivros.com.br',
      'url': 'mailto:parcerias@taglivros.com.br'
    },
    {
      'id': 3,
      'logo': mail,
      'name': 'influenciadores@taglivros.com.br',
      'url': 'mailto:influenciadores@taglivros.com.br'
    }
  ],
  'title': 'Contatos para parcerias:'
}

const ourProducts = {
  'navigationList': [
    {
      'id': 1,
      'name': 'Curadoria',
      'url': PathNavigation.curadoria
    },
    {
      'id': 2,
      'name': 'Inéditos',
      'url': PathNavigation.ineditos
    },
    {
      'id': 3,
      'name': 'Experimente por R$34,90',
      'url': PathNavigation.alternativeIneditos,
      'useHeading': true
    },
    {
      'id': 4,
      'name': 'Kits passados',
      'url': PathNavigation.kitsPassados
    },
    {
      'id': 5,
      'name': 'TAG Trilhas',
      'url': PathNavigation.trilhasTAG,
      'useHeading': true
    },
    {
      'id': 6,
      'name': '#Desafio1LivroPorMes',
      'url': PathNavigation.desafio1LivroPorMes,
      'useHeading': true
    },
    {
      'id': 7,
      'name': 'Blog',
      'url': PathNavigation.blog,
      'useHeading': true
    },
    {
      'id': 8,
      'name': 'Loja',
      'url': 'https://loja.taglivros.com/'
    }
  ],
  'title': 'Nossos Produtos'
}

const aboutTag = {
  'navigationList': [
    {
      'id': 1,
      'name': 'Trabalhe conosco',
      'url': 'https://carreiras.taglivros.com/'
    },
    {
      'id': 2,
      'name': 'Parceria de divulgação',
      'url': 'https://clube.taglivros.com/embaixataggers'
    },
    {
      'id': 3,
      'name': 'Termos, Políticas e Regulamentos',
      'url': 'https://duvidas.taglivros.com/pt-BR/articles/5920975-termos-de-uso-politicas-de-privacidade-e-regulamentos'
    }
  ],
  'title': 'Sobre a TAG'
}

const contactUs = {
  'navigationList': [
    {
      'id': 1,
      'name': 'Central de ajuda para associados',
      'url': 'https://duvidas.taglivros.com/pt-BR/'
    },
    {
      'id': 2,
      'name': 'Login',
      'url': PathNavigation.login
    },
    {
      'id': 3,
      'logo': whatsapp,
      'name': 'Whatsapp: (51) 99196-8623',
      'url': 'https://api.whatsapp.com/send/?phone=555191968623&text=Oi,+TAG!&app_absent=0'
    },
    {
      'id': 4,
      'logo': mail,
      'name': 'contato@taglivros.com.br',
      'url': 'mailto:contato@taglivros.com.br'
    },
  ],
  'title': 'Suporte',
}

const paymentMethods = [
  { 'alt': 'Visa', 'id': 1, 'src': visa, },
  { 'alt': 'Mastercard', 'id': 2, 'src': mastercard },
  { 'alt': 'AMEX', 'id': 3, 'src': amex },
  { 'alt': 'Elo', 'id': 4, 'src': elo },
  { 'alt': 'Hipercard', 'id': 5, 'src': hipercard },
  { 'alt': 'Pix', 'id': 6, 'src': pix },
]

const tagAddress = {
  'city': 'Porto Alegre, RS',
  'cnpj': 'CNPJ: 19.750.274/0001-26',
  'mapUrl': 'https://www.google.com.br/maps/place/Tv.+S%C3%A3o+Jos%C3%A9,+455+-+Navegantes,+Porto+Alegre+-+RS,+90240-200/@-29.9964175,-51.2034852,17z/data=!3m1!4b1!4m5!3m4!1s0x9519798b469b9df5:0x63566daf1560767a!8m2!3d-29.9964175!4d-51.2012965',
  'street': 'Tv. São José, 455',
  tagLogo,
  'tagLogoAlt': 'TAG Experiências Literárias'
}

const termsAndPolicy = {
  'text': 'Termos de serviço e Política de Privacidade e Segurança',
  'url': PathNavigation.privacidadeTermosRegulamento
}
const mobileStores = [
  {
    'id': 1,
    'name': 'App Store',
    'storeLogo': appStoreLogo,
    'storeLogoAlt': 'Icone da Apple',
    'url': 'https://itunes.apple.com/br/developer/tag-comercio-de-livros-ltda-me/id1290878025?mt=8',
  },
  {
    'id': 2,
    'name': 'Google Play',
    'storeLogo': googlePlayLogo,
    'storeLogoAlt': 'Icone do Android',
    'url': 'https://play.google.com/store/apps/developer?id=TAG%20Livros&hl=pt_BR',
  }
]

const storesImages = [
  {
    'id': 1,
    'src': appStoreLogo,
  },
  {
    'id': 1,
    'src': googlePlayLogo,
  }
]

export {
  aboutTag,
  contactUs,
  contactMail,
  mobileStores,
  storesImages,
  ourProducts,
  paymentMethods,
  tagAddress,
  termsAndPolicy
}
